import React from 'react';
import { AssetUrls } from 'config/assets';
import FeatureCardLayout from './FeatureCardLayout';
import './EliteBadgeCard.css';

interface EliteBadgeCardProps {
  isElite: boolean;
}

const EliteBadgeCard: React.FC<EliteBadgeCardProps> = ({ isElite }) => {
  const preview = (
    <div className="elite-badge-card-preview">
      <img
        src={AssetUrls.icons.elite.badge}
        alt="Elite Badge"
        width={88}
        height={88}
      />
    </div>
  );

  const cta = isElite ? (
    <p className="feature-card-aspirational" style={{ fontStyle: 'normal', color: '#22c55e' }}>
      Your badge is active everywhere
    </p>
  ) : (
    <p className="feature-card-aspirational">
      Stand out across the entire platform
    </p>
  );

  return (
    <FeatureCardLayout
      title="Elite Badge Everywhere"
      description="A distinctive badge appears next to your username on every page: trades, leaderboard, inbox, and profile. Everyone knows you're Elite."
      previewContent={preview}
      ctaContent={cta}
      className="elite-badge-card"
    />
  );
};

export default EliteBadgeCard;
